import { ResponseDTO } from './response-dto';

export interface SaveUserContextRoleResponseDTO extends ResponseDTO {
    userId?: number;
}
